// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__kT0TR","tgSafeArea":"styles_tgSafeArea__+sRzV","menuItem":"styles_menuItem__EPLnO","activeMenu":"styles_activeMenu__fqmVf"};